function countdownUpdate() {
    const now = new Date();
    const countDownDate = new Date("2025-05-05T22:59:59Z");
    const distance = countDownDate - now;

    const timeParts = {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
    };

    const updateElements = (prefix) => {
        document.getElementById(`${prefix}-sale-days`).innerHTML = timeParts.days;
        document.getElementById(`${prefix}-sale-hours`).innerHTML = timeParts.hours;
        document.getElementById(`${prefix}-sale-minutes`).innerHTML = timeParts.minutes;
        document.getElementById(`${prefix}-sale-seconds`).innerHTML = timeParts.seconds;
    };

    if (document.getElementById("announcement-countdown")) updateElements("announcement");
    if (document.getElementById("product-countdown")) updateElements("product");
}

if (document.getElementById("announcement-countdown") || document.getElementById("product-countdown")) {
    countdownUpdate();
    setInterval(countdownUpdate, 1000);
}

function updateCounters(){
    const counters = ["page-counter-text", "cart-counter-text"];
    counters.forEach(function(counter) {
        const el = document.getElementById(counter);
        if(el) el.innerHTML = Math.floor(Math.random() * (Number(el.dataset.max) - Number(el.dataset.min) + 1)) + Number(el.dataset.min);
    });
}

function liveChatLink(){
  document.querySelectorAll('.link.animate-arrow').forEach(function(chatLink) {
    if(chatLink.getAttribute("href") == "#chat" && GorgiasChat){
      chatLink.addEventListener('click',function(){
          GorgiasChat.open();
      });
    }
  });
}

function footerNavItems(){
    const mobileNavItems = document.querySelectorAll('.footer-block__heading');
    mobileNavItems.forEach((item) => {
        item.addEventListener('click', () => {
            item.querySelector('.svg-wrapper').classList.toggle('rotate');
            item.nextElementSibling.classList.toggle('open');
        });
    });
}

function initFirstTime(){

    const sessionKeysToClear = ["myWhitesCredit", "myWhitesReferralLink", "myWhitesTier", "myWhitesOrderCount"];
    sessionKeysToClear.forEach((key) => sessionStorage.removeItem(key));

    const pathname = window.location.pathname;
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    function populateField(id, value) {
        const field = document.getElementById(id);
        if (field && value) {
            field.value = value;
        }
        return field;
    }

    if (pathname === "/account/login" && params.email) {
        populateField('CustomerEmail', params.email);
        const passwordField = document.getElementById('CustomerPassword');
        if (passwordField) passwordField.focus();
    }

    if(pathname === "/account/register"){
        if(!sessionStorage.myWhitesSource && (params && params.whites_source)) {
            sessionStorage.myWhitesSource = params.whites_source;
        }

        if(sessionStorage.myWhitesSource){
            const tag_input = document.getElementById('RegisterForm-tags');
            tag_input.value = sessionStorage.myWhitesSource;
            tag_input.disabled = false;

            const customer_form = document.getElementById('create_customer');
            customer_form.setAttribute("data-login-with-shop-sign-up","false");
        } else {
            console.log("No customer tags found");
        }
    }

    if (pathname === "/account/register" && params.finish_account) {

        populateField('RegisterForm-FirstName', params.first_name);
        populateField('RegisterForm-LastName', params.last_name);
        populateField('RegisterForm-email', params.email);

        const accountHeader = document.getElementById('create-account-header');
        if (accountHeader) accountHeader.textContent = 'Finish creating account';

        const passwordField = document.getElementById('RegisterForm-password');
        if (passwordField) passwordField.focus();
    
    }

}

document.addEventListener('DOMContentLoaded', function() {
    updateCounters();
    liveChatLink();
    footerNavItems();
});


function formatQuestionsAndAnswers(quizData) {
  if (!quizData.answers) return '';
  return Object.entries(quizData.answers)
    .filter(([q]) => q.startsWith('Octane:'))
    .map(([q, a]) => `
      <div class="quiz-qa-item">
        <p class="quiz-question">${q.replace('Octane: ', '')} - <strong>${a}</strong></p>
      </div>
    `).join('');
}

function createProductCards(quizData) {
  const products = quizData.product_blocks[0];
  const cheapestPrice = Math.min(...products.map(p => p.price));

  return products.map((product, index) => {
    const { title, image, id, link, variants } = product;
    const variant = variants[0];
    const { price, compare_at_price, price_formatted, compare_at_price_formatted, id: variantId } = variant;

    const isOnSale = compare_at_price > price;
    let badgeText = null;

    if (index === 0) badgeText = "Primary Recommendation";
    else if (index === 1) badgeText = "Secondary Recommendation";
    else if (/Toothpaste|Powder/.test(title)) badgeText = "Maintain";

    let rating = 4.9;
    let raters = 5673;

    const badgeHTML = badgeText
      ? `<div class="card__badge top right" style="z-index: 1000;position: relative;margin-right: 5px;margin-top: 2px;">
           <span class="badge badge--bottom-left color-scheme-3">${badgeText}</span>
         </div>`
      : '';

    const priceHTML = isOnSale
      ? `<div class="price price--on-sale">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span class="price-item price-item--regular">
                <span class="money">${price_formatted}</span>
              </span>
            </div>
            <div class="price__sale">
              <span><s class="price-item price-item--regular"><span class="money">${compare_at_price_formatted}</span></s></span>
              <span class="price-item price-item--sale price-item--last"><span class="money">${price_formatted}</span></span>
            </div>
          </div>
        </div>`
      : `<div class="price">
          <div class="price__container">
            <div class="price__regular">
              <span class="price-item price-item--regular">
                <span class="money">${price_formatted}</span>
              </span>
            </div>
          </div>
        </div>`;

    return `
      <li class="grid__item scroll-trigger animate--slide-in" data-cascade style="--animation-order: ${index + 1};">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100%;">
            <div class="card__inner color-scheme-1 gradient ratio">
              <div class="card__media">
                ${badgeHTML}
                <div class="media media--transparent media--hover-effect">
                  <img src="${image}" alt="${title}" class="motion-reduce" width="1500" height="1500">
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${link}" class="full-unstyled-link">${title}</a>
                </h3>
                <div class="loox-rating" data-id="${id}"  data-rating="4.9" data-raters="..."></div>
                ${priceHTML}
              </div>
              <div class="quick-add no-js-hidden">
                <product-form>
                  <form method="post" action="/cart/add" id="quick-add-${id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantId}">
                    <input type="hidden" name="product-id" value="${id}">
                    <input type="hidden" name="section-id" value="template--24551470563709__featured_collection">
                    <button id="quick-add-${id}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog">
                      <span>Add to cart</span>
                      <span class="sold-out-message hidden">Sold out</span>
                      <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                      </div>
                    </button>
                  </form>
                </product-form>
              </div>
            </div>
          </div>
        </div>
      </li>
    `;
  }).join('');
}

function loadOctaneResults(e) {
  const quizData = e.detail;
  console.log(quizData);
  const questionsAndAnswers = formatQuestionsAndAnswers(quizData);
  const quizSection = document.getElementsByClassName('octane-ai-quiz-rendered')[0];
  quizSection.style.display = 'none';

  document.querySelector('#whites-quiz-results-wrapper').innerHTML = `
    <section id="shopify-section-template--24551470563709__recommendations" class="shopify-section section">
      <link href="//whitesbeaconsfield.co.uk/cdn/shop/t/172/assets/section-rich-text.css" rel="stylesheet" media="all">
      <link href="//whitesbeaconsfield.co.uk/cdn/shop/t/172/assets/quick-add.css" rel="stylesheet" media="all">
      <style>
        .section-template--24551470563709__recommendations-padding {
          padding: 30px 0;
        }
        @media screen and (min-width: 750px) {
          .section-template--24551470563709__recommendations-padding {
            padding: 40px 0;
          }
        }
        section[id*="featured_collection_UemWMf"] {
          display: none;
        }
      </style>
      <div class="isolate page-width" style="margin-top: 10px;">
        <div class="rich-text content-container color-scheme-2 gradient section-template--24551470563709__recommendations-padding">
          <div class="rich-text__wrapper rich-text__wrapper--center">
            <div class="rich-text__blocks center">
              <h2 class="rich-text__heading rte inline-richtext h2 scroll-trigger animate--slide-in">Your Recommendations</h2>
              <div class="rich-text__text rte scroll-trigger animate--slide-in">
                <p>Thanks for taking the quiz. Based on your answers, here's what we recommend. Want to see your answers? Click below.</p>
              </div>
              <div class="rich-text__buttons scroll-trigger animate--slide-in">
                <button id="show-answers" onclick="toggleAnswers(true)" class="button button--primary">View your answers</button>
                <button id="hide-answers" style="display:none;" onclick="toggleAnswers(false)" class="button button--secondary">Hide your answers</button>
              </div>
              <div id="quiz-answers" class="quiz-answers" style="display: none; text-align: left; margin: 20px 0; padding: 20px; background: #f9f9f9; border-radius: 8px;">${questionsAndAnswers}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="collection page-width">
      <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" id="quiz-results"></ul>
    </div>
    <br />
  `;

  document.querySelector('#quiz-results').innerHTML = createProductCards(quizData);
}

function toggleAnswers(show) {
  document.getElementById('quiz-answers').style.display = show ? 'block' : 'none';
  document.getElementById('show-answers').style.display = show ? 'none' : 'inline-block';
  document.getElementById('hide-answers').style.display = show ? 'inline-block' : 'none';
}

['octane.quiz.accessed', 'octane.quiz.completed'].forEach(eventName => {
  document.addEventListener(eventName, loadOctaneResults, false);
});